<template>
    <div v-bind:style="style" v-if="isReady">
        <html-editor
                ref="editor"
                
                v-bind:value="initialText"
                v-bind:theme="themes.bubble"
                v-bind:toolbar-module="toolbarModule"
                v-bind:toolbar-defaults="toolbarDefaults"

                @input="$emit('text-changed', $event)"
        ></html-editor>
    </div>
</template>

<script>
    import dataStore from '../../Util/data-store';
    
    import rulesetGenerator  from '../../CustomStylingOptions/ruleset-generator';
    
    import fontSizes from '../../CustomStylingOptions/font-sizes';
    import headingSizes from '../../CustomStylingOptions/heading-sizes';
    import fonts from '../../CustomStylingOptions/fonts';
    
    import {DEFAULT_SETTINGS_DATASTORE_KEY} from "../Template.vue";

    import dnxVariableOptions from '../../../../Components/Util/HtmlEditor/CustomBlots/dnx-variable-options';
    import HtmlEditor, {themes} from '../../../../Components/Util/HtmlEditor/HtmlEditor.vue';
    
    //Copy as to not push our 'false' value into the source array
    const headers = headingSizes.slice();
    
    //Option to disable heading for selected text
    headers.unshift(false);
    
    const quillDefault = [];
    
    const textStyles = ['bold', 'italic', 'underline', 'strike', 'link'];
    
    export default {
        name: "template-manager-block-text-content",
        components: {
            HtmlEditor
        },
        created(){
            const vm = this;
            
            vm.text = vm.metadata.text;

            //Quill stops working when we use our text as both input and the variable we write it's output to
            vm.initialText = vm.text;
            
            //Set our defaults + add a watch for any potential changes
            vm.setDefaults(dataStore.get(DEFAULT_SETTINGS_DATASTORE_KEY));
            vm.watchId = dataStore.startWatch(DEFAULT_SETTINGS_DATASTORE_KEY, defaults => vm.setDefaults(defaults));

            dnxVariableOptions.then((variables) => {
                vm.dnxVariables = variables;
            });

        },
        destroyed(){
            dataStore.stopWatch(this.watchId);
        },
        methods: {
            setDefaults(defaults){
                const vm = this;
                
                vm.toolbarDefaults.font = defaults.font;
                vm.toolbarDefaults.size = defaults.fontSize;
                
                //After our editor has been fully initialized
                //A re-initializing is necessary for our new defaults to take place
                if(vm.$refs.editor){
                    vm.$refs.editor.reInitialize();
                }
            }
        },
        data(){
            const vm = this;

            return {
                watchId: '',
                dnxVariables: null,      
                themes,
                toolbarDefaults: {},
                text: '',
                initialText: ''
            }
        },
        computed: {
            
            toolbarModule(){
                const vm = this;

                return [
                    [{ 'header': headers }],
                    [{ 'font': fonts }],
                    [{ 'size': fontSizes }],
                    [{ 'color': quillDefault }, { 'background': quillDefault }],
                    textStyles,
                    [{ 'align': quillDefault }, { 'list': 'ordered'}, { 'list': 'bullet' }],
                    ['clean'],
                    [{'dnxVariable':  vm.dnxVariables }]
                ]
            },
            style(){
                const vm = this;
                
                const ruleset = rulesetGenerator();
                
                //Prevent dividing by 0 
                const horizontalMargin = vm.metadata.style.horizontalMargin ? vm.metadata.style.horizontalMargin / 2 : 0;
                const verticalMargin = vm.metadata.style.verticalMargin ? vm.metadata.style.verticalMargin / 2 : 0;
                
                ruleset.setRule('display', 'block');
                ruleset.setRule('position', 'relative');
                ruleset.setRule('margin-right', `${horizontalMargin}px`);
                ruleset.setRule('margin-left', `${horizontalMargin}px`);
                ruleset.setRule('margin-top', `${verticalMargin}px`);
                ruleset.setRule('margin-bottom', `${verticalMargin}px`);
                
                return ruleset.toString();
            },
            isReady() {
                return this.dnxVariables != null;
            }
        },
        props: {
            metadata: Object
        }
    };
</script>
